import type { Language } from "@/lib/i18n";

/** OG/Twitter card dimensions and MIME type. */
export const SHARE_IMAGE = {
    width: 1200,
    height: 630,
    alt: "ScaMatrix - AI Powered Threat Intelligence Lookup Service",
    type: "image/png" as const,
};

/** Static PNG per locale — used for both og:image and twitter:image. */
export function buildStaticShareImagePath(lang: Language): string {
    return `/images/share/${lang}.png`;
}
